module.exports = __webpack_public_path__ + "img/webnew39.7b575908.jpg";